import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: () => ({
    userData: null,
    showLogin: false,
    isLogged: false,
  }),
  actions: {
    setUser(data) {
      this.userData = data;
    },
    setLoginView(data) {
      this.showLogin = data;
    },
  },
});
